import React from 'react';

export default function ArtistArtworkMedia({src, alt, preview = false, ...props}) {
    if (!src) return null;

    if (/\.(mp4|webm|ogg)(?:[?#]|$)/i.test(src)) {
        return (
            <video
                {...props}
                key={src}
                src={src}
                aria-label={alt}
                autoPlay
                muted
                loop
                playsInline
                controls={preview}
                preload="metadata"
            />
        );
    }

    return <img {...props} src={src} alt={alt}/>;
}
